import { Label, Radio, RadioField, RadioGroup, TextInput } from '@d-edge/overnight-hotelier-react'
import { IconButton } from '@/components/ui/Button'
import { Icons } from '@/components/ui/Icons'
import { MetricFields } from './MetricFields'
import type { RuleDraft, RuleKind } from './scalability'
import { ScheduleFields } from './ScheduleFields'
import styles from './ScalabilityDialog.module.css'

interface RuleEditorProps {
  rule: RuleDraft
  /** 1-based position in the list. */
  position: number
  onChange: (patch: Partial<RuleDraft>) => void
  onDelete: () => void
}

/** One bordered block per rule: name, kind, and the fields of that kind. */
export function RuleEditor({ rule, position, onChange, onDelete }: RuleEditorProps) {
  return (
    <div className={styles.rule} role="group" aria-label={rule.name.trim() || `Rule ${position}`}>
      <div className={styles.ruleHeader}>
        <TextInput fullWidth value={rule.name} placeholder={`Rule ${position}`} aria-label={`Name of rule ${position}`} onChange={(e) => onChange({ name: e.target.value })} />
        <IconButton label={`Delete rule ${position}`} onClick={onDelete}>
          <Icons.Trash size={14} />
        </IconButton>
      </div>

      <RadioGroup
        name={`rule-${rule.key}-kind`}
        value={rule.kind}
        onChange={(kind) => onChange({ kind: kind as RuleKind })}
        aria-label={`Type of rule ${position}`}
        className={styles.kind}
      >
        <RadioField>
          <Radio value="Metric" />
          <Label>Scale based on a metric</Label>
        </RadioField>
        <RadioField>
          <Radio value="Schedule" />
          <Label>Scale to a specific instance count</Label>
        </RadioField>
      </RadioGroup>

      {rule.kind === 'Metric' ? <MetricFields rule={rule} position={position} onChange={onChange} /> : <ScheduleFields rule={rule} position={position} onChange={onChange} />}
    </div>
  )
}
